export const ModalboxConfig = {
    componentTypeKey: 'Modalbox',

    htmlId: 'modalbox',
    baseHtmlClass: 'modalbox',
    selector: '.modalbox',

    datasetConfigKey: 'modalbox_config',
    sourceUrlDataKey: 'modalbox__source_url',  // Set on content element when loaded via Modalizer

    uninitializedHtmlClass: 'modalbox--uninited',
    initializedHtmlClass: 'modalbox--inited',
    notInitializedSelector: '.modalbox:not(.modalbox--inited)',

    loadedEventName: 'Rankers.Modalbox:Loaded',
    initializedEventName: 'Rankers.Modalbox:Initialized',
    closeEventName: 'Rankers.Modalbox:Close',
    openEventName: 'Rankers.Modalbox:Open',
    contentChangeEventName: 'Rankers.Modalbox:ContentChanged',

    // Fired once per open, when the modalbox is open, HAS content, and its open animation has
    // finished — i.e. when the box has stopped moving and injected content may trust its own
    // dimensions. Deliberately NOT named "Loaded": that reads as "the content has arrived",
    // which is what contentChangeEventName already says, and content can arrive long before
    // the box has finished resizing around it. `.modalbox__liner` carries
    // `transition: width 500ms, height 500ms`, so there is a real window in which content is
    // present and every measurement of it is wrong.
    //
    // Content that measures itself — anything computing slide positions, scroll offsets or
    // intersection — should wait for this rather than inventing its own gate. The state is
    // also published as the `modalbox--settled` class, so late-arriving content can ask
    // whether it has already happened instead of waiting for an event it just missed.
    settledEventName: 'Rankers.Modalbox:Settled',
};
